import { IPresentationData } from '@tencent/slide-sdk-model';
import { ISlideType, SlideType } from './define';

export function matchLayoutIdByType(layoutMap: IPresentationData['layoutMap']): Record<ISlideType, string> {
  const nameMap = {
    [SlideType.cover]: ['封面', '标题幻灯片'],
    [SlideType.catalogue]: ['目录页', '目录'],
    [SlideType.session]: ['节标题', '章节页'],
    [SlideType.page]: ['仅标题', '空白页'],
    [SlideType.ending]: ['封底'],
  };
  const layoutList = Object.values(layoutMap);
  const mapping = layoutList.reduce<Record<SlideType, string>>(
    (resultMap, layout) => {
      const layoutName = layout.cSld.name;
      if (!layoutName) return resultMap;

      [SlideType.cover, SlideType.catalogue, SlideType.session, SlideType.page, SlideType.ending].forEach((type) => {
        if (nameMap[type].includes(layoutName)) {
          resultMap[type] = layout.id;
        }
      });

      return resultMap;
    },
    {} as Record<SlideType, string>,
  );

  // cover 用第一个 layout 兜底
  mapping[SlideType.cover] = mapping[SlideType.cover] || layoutList[0].id;
  // page 用最后一个 layout 兜底
  mapping[SlideType.page] = mapping[SlideType.page] || layoutList[layoutList.length - 1].id;

  // 其他的用 page 兜底
  mapping[SlideType.catalogue] = mapping[SlideType.catalogue] || mapping[SlideType.page];
  mapping[SlideType.session] = mapping[SlideType.session] || mapping[SlideType.page];
  mapping[SlideType.ending] = mapping[SlideType.ending] || mapping[SlideType.page];

  return mapping;
}
